// NOTE: if changing this, please re-generate src/styles/theme.module.scss per Polaris documentation:
// https://github.com/Shopify/polaris/blob/main/documentation/guides/migrating-from-v8-to-v9.md#replacing-custom-properties-from-theme-overrides
// TODO: handle this in TAP-720 https://talkiatry.atlassian.net/browse/TAP-720
export const TALKIATRY_THEME_ADMIN_URL = {
  colors: {
    surface: '#f8f6f2',
    onSurface: '#111213',
    primary: '#469BC3',
    secondary: '#E1DACD',
    interactive: '#469BC3',
    critical: '#D32222',
    warning: '#FFCC33',
    success: '#3BAD1F',
    highlight: '#5DBAE0',
  },
  logo: {
    url: '/admin',
    topBarSource: '/logo.svg',
    accessibilityLabel: 'Talkiatry',
    width: 120,
  },
};

export const TALKIATRY_THEME_HOMEPAGE_URL = {
  ...TALKIATRY_THEME_ADMIN_URL,
  logo: {
    ...TALKIATRY_THEME_ADMIN_URL.logo,
    url: 'https://www.talkiatry.com/',
  },
};

export const TALKIATRY_PHONE_NUMBER_DISPLAY = '(833) 351-8255';
export const TALKIATRY_PHONE_NUMBER_TEL_URL = 'tel:833-351-8255';

export const VALID_DAY = /^\d{4}-\d{2}-\d{2}$/;
export const VALID_DATE =
  /^(19|20)\d{2}-(0[1-9]|1[0-2])-(0[1-9]|1\d|2\d|3[01])$/;
export const VALID_PHONE_WITH_OPTIONAL_CHARACTERS =
  /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
export const VALID_PHONE = /^\d{10}$/;
export const VALID_ZIPCODE = /^\d{5}(?:[-\s]\d{4})?$/;
export const VALID_EMAIL = /^[^\s@]+@[^\s@.]+\.[^\s@]+$/;
export const VALID_URL =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/;
export const VALID_HEALOW_CODE = /[A-Z0-9]{3}-[A-Z0-9]{3}-[A-Z0-9]{4}/;
export const EVENT_BOT = {
  name: 'TalkBot',
  email: 'no-reply@mail.talkiatry.com',
};
export const INVALID_HEALOW_NAME_MESSAGE =
  'Name must start with a letter and contain no special characters other than ( ) . \' , - " and space.';

export const NewPatientAppointmentTimeGaps = ['0', '15', '30'];

export const EXCLUSIVE_OPTION = 'No, none of these apply';

export const V2POINT1_EXCLUSIVE_OPTION_FOR_SECONDARY = 'No, none of these';

export const DISCOVERY_CHANNEL_OPTIONS = [
  'A friend or relative',
  'A therapist',
  'Another doctor',
  'Facebook',
  'Google or another search engine',
  "Insurer's website",
  'Instagram',
  'LinkedIn',
  'Online article or blog post',
  'Podcast',
  'Psychology Today',
  'Reddit',
  'Spotify',
  'Streaming TV (e.g., Hulu, Peacock)',
  'TikTok',
  'TV',
  'YouTube',
  'Zocdoc',
  'Other',
];

export enum ScheduleRequestVisitType {
  TELE_FU_L = 'TELE F/U L', // Televisit follow up - >30 minutes
  TELE_FU_S = 'TELE F/U S', // Televisit follow up - =30 minutes
  TELE_NP = 'TELE NP', // Televisit new patient
  TELE_REFER = 'Tele Refer', // Televisit referral
}

export enum ScheduleRequestNewPatientVisitType {
  TELE_NP = 'TELE NP',
  TELE_REFER = 'Tele Refer',
}

export enum ScheduleRequestVisitStatus {
  PENDING = 'PEN',
  CANCELLED = 'CANC',
}
